export default "__VITE_ASSET__Cgws26zH__"